import { ListItemRoot } from "./list-item";
import {
  ListItemContent,
  ListItemContentSupportingText,
  ListItemContentTitle,
} from "./list-item-content";
import {
  ListItemLeadingAvatar,
  ListItemLeadingIcon,
  ListItemLeadingImage,
} from "./list-item-leading";
import { ListItemTrailing, ListItemTrailingIcon, ListItemTrailingText } from "./list-item-trailing";

export const ListItem = Object.assign(ListItemRoot, {
  LeadingIcon: ListItemLeadingIcon,
  LeadingAvatar: ListItemLeadingAvatar,
  LeadingImage: ListItemLeadingImage,
  Content: ListItemContent,
  ContentTitle: ListItemContentTitle,
  ContentSupportingText: ListItemContentSupportingText,
  Trailing: ListItemTrailing,
  TrailingText: ListItemTrailingText,
  TrailingIcon: ListItemTrailingIcon,
});

export type {
  ListItemProps,
  ListItemTone,
  ListItemLayout,
  ListItemLeadingIconProps,
  ListItemLeadingAvatarProps,
  ListItemLeadingImageProps,
  ListItemContentProps,
  ListItemContentTitleProps,
  ListItemContentSupportingTextProps,
  ListItemTrailingProps,
  ListItemTrailingTextProps,
  ListItemTrailingIconProps,
} from "./types";
